import {Component, OnInit} from "@angular/core";

@Component({
  templateUrl: './profiles-root-page.component.html'
})
export class ProfilesRootPageComponent implements OnInit {
  constructor() {
  }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/pages/profiles/profiles-root-page.component.ts